/**
 * React Query hooks da feature de resumos (F12 Wave 8).
 */

import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../../shared/data/queryKeys';
import { listSummaries } from './api';

export function useSummariesList(q: string) {
  return useQuery({
    queryKey: queryKeys.summariesList(q),
    queryFn: () => listSummaries(q),
  });
}
